"use strict";

define('model/template',['./base'], function (BaseModel) {
  var Template = BaseModel.extend({
    syncFormTemplate: function syncFormTemplate() {
      return this.request('/rs/api/form/get/:id/:revisionNumber');
    }
  }, {
    allPublished: function allPublished() {
      return this.createCollection('/rs/api/form/get/published/:studyId');
    },
    allPublishedByStudyId: function allPublishedByStudyId(studyId) {
      return this.createCollection('/rs/api/form/get/published/:studyId').params({
        studyId: studyId
      });
    }
  });
  return Template;
});

